import styled from 'styled-components';

export const GAME_CARD_BREAKPOINT = 400;

export const GameCardWrapper = styled.div<{ hasBorderRadius?: boolean }>`
	display: grid;
	grid-template-columns: 1fr;
	grid-auto-flow: dense;
	gap: 12px;
	padding: 12px;
	border-bottom: 1px solid var(--main-background);
	background-color: var(--main-surface-1);

	border-radius: ${({ hasBorderRadius }) => hasBorderRadius && 'var(--base-radius-large)'};

	&:only-of-type {
		padding: 12px;
	}

	&:last-of-type {
		border-bottom-left-radius: var(--base-radius-large);
		border-bottom-right-radius: var(--base-radius-large);
		border-bottom: none;
	}
`;

export const GameCardDetails = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;

	svg {
		width: 20px;
		height: 20px;
	}
`;

export const GameCardContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	position: relative;
`;
